import { useEffect, useState } from "react";
import useAuthHttp from "./useAuthHttp";

export interface IVehicleBrandResult {
    vehicle_brand_list: IVehicleBrandList[]
}
  
export interface IVehicleBrandList {
    id: string
    brand_label: string
    brand_value: string
}
 
export interface IVehicleBrand {
    id: string;
    name: string;
    value: string;
}

export const useFindVehicleBrand = () => {
    const { doGet } = useAuthHttp();
    const [vehiclesSearch, setVehiclesSearch] = useState<IVehicleBrand[]>([]);
    const [loadingVehicles, setLoadingVehicles] = useState(false);

    useEffect(() => {
        const loadVehicles = async () => {
            setLoadingVehicles(true);
    
            try {
                const result = await doGet<IVehicleBrandResult>(`/vehicle/brand/list`);
        
                setVehiclesSearch(result?.vehicle_brand_list?.map(v => ({ id: v.id, name: v.brand_label, value: v.brand_value })) ?? []);
            } finally {
                setTimeout(() => {
                    setLoadingVehicles(false);
                }, 1000);
            }
        }

        loadVehicles().then();
    }, []);
    
    const findVehicleBrandByName = async (name: string): Promise<IVehicleBrand[]> => {
        return Promise.resolve(vehiclesSearch.filter(v => v.name.toLowerCase().includes(name.toLowerCase())));
    }

    return { findVehicleBrandByName, loadingVehicles };
}
